import type { ReactNode } from 'react';
import * as React from 'react';
import { Fragment, useEffect } from 'react';

import type ApolloClient from 'apollo-client';

type Props = {
  apolloClient: ApolloClient<$TSFixMe>;
  children?: ReactNode;
};

const ResetCacheOnUnmountWrapper = ({ apolloClient, children }: Props) => {
  useEffect(() => {
    return () => {
      // Here we reset the apollo store to the context of the given apollo client on "unmount".
      // Resetting store clears out the cache for the given client but allows all active queries
      // to remain active and rerun when needed to a fresh state
      apolloClient.cache.reset();
    };
    // we do not want apolloClient to be a dependency of this effect as we don't want behavior
    // changes on changes within the client
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <Fragment>{children}</Fragment>;
};

export default ResetCacheOnUnmountWrapper;
